import { z } from 'zod'

/** @deprecated */
const planStatus = z.object({
    active: z.boolean().optional(),
    /** unix epoch after which plan expires */
    validUntil: z.number().optional(),
})

/**
 * State that defines which modules is an ORNA
 * organization currently subscribed to
 */
/** @deprecated */
export const Subscription__schema = z.object({
    plan: planStatus.optional(),
    practice: planStatus.optional(),
    respond: planStatus.optional(),
    monitor: planStatus.optional(),
})

// /** @type {z.infer<typeof Subscription__schema>} */
// const subscription = {}

export const ModuleSchema = z.object({
    module_name: z.enum(['plan', 'practice', 'respond', 'monitor']),
    is_trial: z.boolean(),
    status: z.enum(['active', 'cancelled', 'expired']),
    will_renew: z.boolean(),
    cancelled_at: z.date().nullable(),
    created_at: z.date(),
    start_date: z.date(),
    end_date: z.date(),
})

export const BillingStateSchema = z.object({
    created_at: z.date(),
    start_date: z.date(),
    end_date: z.date(),
    status: z.enum(['active', 'cancelled', 'expired']),
    billing_method: z.enum(['email', 'credit_card']).nullable(),
    billing_frequency: z.enum(['monthly', 'annual']).nullable(),
    subscription_modules: z.array(ModuleSchema),
    is_trial: z.boolean(),
})
